import React from "react";
import { Card } from "antd";
import styles from "./index.module.less";

/**
 * Reusable wrapper for charts with optional title and consistent styling.
 * Use in dashboard, analytics, or any section that needs a chart in a card.
 */
const ChartCard = ({ title, children, className, loading, ...rest }) => {
  return (
    <Card
      className={`${styles.chartCard} ${className || ""}`}
      loading={loading}
      {...rest}
    >
      {title && <div className={styles.chartCardTitle}>{title}</div>}
      <div className={styles.chartCardContent}>{children}</div>
    </Card>
  );
};

export default ChartCard;
